import { createStore } from "vuex";
import usersModule from "@/store/modules/usersModule";
import platformsModule from "./modules/platformsModule";
import examModule from "@/store/modules/examModule";
import examStudentsModule from "@/store/modules/examStudentsModule";
import currentUserModule from "@/store/modules/currentUserModule";
import schoolsModule from "@/store/modules/schoolsModule";
import gradesModule from "@/store/modules/gradesModule";
import studentsModule from "@/store/modules/studentsModule";
import reportsListingModule from "./modules/reportsListingModule";
import studentExamsModule from "./modules/studentExamsModule";
import demo from "./modules/demo";
import CreateLocalPop from "./modules/Localization/CreateLocalPop";
import localExamModule from './modules/Localization/PublishModule';
import saveCountries from './modules/Localization/saveCountries';
import changeCountries from './modules/Localization/changeCountriesModule';
import errorPopup from './modules/Localization/errorPopupModule';
import editRestrictionModule from './modules/Localization/editRestrictionModule';



const store = createStore({
  modules: {
    platforms: platformsModule,
    demo: demo,
    currentUser: currentUserModule,
    usersManagement: usersModule,

    examForm: examModule,
    assignedStudents: examStudentsModule,
    errorPopup :errorPopup,
    schools: schoolsModule,
    grades: gradesModule,
    students: studentsModule,
    studentExams: studentExamsModule,
    changeCountries:changeCountries,
    reports: reportsListingModule,
    CreateLocalPop: CreateLocalPop,
    localExam: localExamModule,
    saveCountries: saveCountries,
    editRestrictionModule: editRestrictionModule
  },
});

export default store;
